import React from 'react';
import { twoDigit } from '../format';

/**
 * The fixed left rail: stacked chapter numbers plus the vertical wordmark.
 *
 * Numbers are buttons rather than anchors so the scroll happens on the story
 * scroller itself — the page is not the document scroller, and hash navigation
 * would fight the app's router.
 *
 * Below 900px the same markup renders as a horizontal strip across the top
 * (see `story.css`).
 *
 * @param {Object} props
 * @param {number} props.count - Number of chapters rendered
 * @param {number} props.active - 1-based active chapter
 * @param {(index: number) => void} props.onSelect
 */
function Rail({ count, active, onSelect }) {
  return (
    <nav className="story-rail" aria-label="Story chapters">
      <div className="story-rail-numbers">
        {Array.from({ length: count }, (_, i) => i + 1).map((index) => (
          <button
            key={index}
            type="button"
            className="story-rail-number"
            aria-current={index === active}
            aria-label={`Go to chapter ${index}`}
            onClick={() => onSelect(index)}
          >
            {twoDigit(index)}
          </button>
        ))}
      </div>
      <div className="story-rail-vertical" aria-hidden="true">
        PORTFOLIO · ALL TIME
      </div>
    </nav>
  );
}

export default Rail;
